module.exports = __webpack_public_path__ + "static/img/money-active.f22f675.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/money-active.png
// module id = DS8b
// module chunks = 1